import { render } from "./AddMatchInfo.vue?vue&type=template&id=0fe00cf8"
import script from "./AddMatchInfo.vue?vue&type=script&lang=js"
export * from "./AddMatchInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__